//export const AuthURL = 'http://sandra.ozip.co.id/api/auth/'; // 3000
//export const DonorURL = 'http://sandra.ozip.co.id/api/dono/'; // 3001
//export const MasterDataURL = 'http://sandra.ozip.co.id/api/mastd/'; // 3002
//export const DonationURL = 'http://sandra.ozip.co.id/api/dona/'; // 3003
//export const DonaturURL =  'http://donatur.dev.ozip.co.id/api/'; // 3010


export const AuthURL = 'http://admin.sandra-dev.dompetdhuafa.org/api/auth/';
export const DonorURL = 'http://admin.sandra-dev.dompetdhuafa.org/api/dono/';
export const MasterDataURL = 'http://admin.sandra-dev.dompetdhuafa.org/api/mastd/';
export const DonationURL = 'http://admin.sandra-dev.dompetdhuafa.org/api/dona/';
export const PublicReportURL = "http://admin.sandra-dev.dompetdhuafa.org/report/"


// export const AuthURL = 'http://localhost:3000/';
// export const DonorURL = 'http://localhost:3001/';
// export const MasterDataURL = 'http://localhost:3002/';
// export const DonationURL = 'http://localhost:3003/';
// export const DonaturURL = 'http://localhost:3010/';
// export const PublicReportURL = "http://localhost:3005/"

